module.exports = __webpack_public_path__ + "img/blog-1.5e63997f.jpg";